module.exports = __webpack_public_path__ + "img/baggage.5c22ffad.svg";